import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Drawer, Grid, Button } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import TableContainer from "@material-ui/core/TableContainer";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import Spinner from "./../../Global/Spinner2";
import NoRecords from "./../../Global/NoRecords";
import { useHistory } from "react-router-dom";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import PersonIcon from "@material-ui/icons/Person";
import Tooltip from "@material-ui/core/Tooltip";
import SearchBar from "./searchbar";
import ScheduleModal from "./detailModal";
import ScheduleManageList from "./scheduleManageFilter";
import start from "../../Assets/start.png";
import up from "../../Assets/up.png";
import dotsH from "../../Assets/dotsH.png";
import startG from "../../Assets/startG.png";
import _ from "lodash";
import moment from "moment";
import {useTranslation} from 'react-i18next';
import { DateTime } from 'luxon';

//Redux
import { useSelector, useDispatch } from "react-redux";

import Colors from "./../../Global/colors";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  container: {
    maxHeight: "50vh",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

export default function ScheduleList({
  schedules,
  scheduleLoader,
  searchText,
}) {
  let { t } = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const [state, setState] = useState({
    Schedule: [],
    filter_arr: null,
  });
  const [templates, setTemplates] = React.useState([]);
  const [currentEditRow, setCurrentEditRow] = React.useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [users, setUsers] = React.useState([]);
  const [currentCompany, setCurrentCompany] = React.useState({});
  const history = useHistory();
  // const [scheduleLoader, setScheduleLoader] = React.useState(false);
  const [packageDetails, setPackageDetails] = React.useState(null);

  async function getPackageDetails(company) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  let company = useSelector((state) => state.companyReducer.company);
  React.useEffect(
    () => {
      setCurrentCompany(company);
      // fetchSchedule(company);
      fetchTemplates(company);
      fetchAllUser(company);
      getPackageDetails(company);
    },
    [company?.id]
  );

  React.useEffect(() => {
    if ("geolocation" in navigator) {
      console.log("Available");
    } else {
      console.log("Not Available");
    }
  }, []);

  const handleClose2 = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const fetchSchedule = (company) => {
  //   setScheduleLoader(true)
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data.token;
  //   let params = {
  //     company_id:company.id,
  //     user_id: data.user_id,
  //   };
  //   console.log(data.user_id);
  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/ScheduleAssignee/get_schedule_weekly?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then(async (response) => {
  //       console.log(response, "[][][][][] DAILY SCHEDULE");
  //       if (response.status === "Success") {
  //         if (response?.data.length > 0 ){
  //         //   let sch = [];
  //         // response?.data
  //         //   .sort((a, b) => new Date(a.filter_date).getTime() - new Date(b.filter_date).getTime())
  //         //   .map((v, i) => {
  //         //     let obj = { ...v, filter_date: moment(v.filter_date).format("MMMM DD, YYYY") };
  //         //     sch.push(obj);
  //         //     console.log("DATA IN ARRAY", sch);
  //         //     setState({ Schedule: sch });
  //         //   });

  //         setState({ Schedule: response?.data });

  //         } else if(response?.data.length == 0){
  //             setState({ Schedule: [] });
  //           }
  //           setScheduleLoader(false)
  //       } else if (response.error === "jwt expired" || response.error === "invalid token" || response.error === "invalid signature" || response.error === "Unexpected token") {
  //         let status = await refresh_token();
  //         console.log(status);
  //         if (status) {
  //           console.log("opopopop");
  //           fetchSchedule(company);
  //         }
  //         setScheduleLoader(false)
  //       }
  //     })
  //     .catch((error) => console.log(error));
  //   console.log("op");
  // };

  const fetchAllUser = (comapny) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        // console.log(response, "{}{}{}{}");
        if (response.status === "Success") {
          setUsers(response?.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchAllUser(comapny);
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  const fetchTemplates = (company) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Template/get_all_templates?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        // console.log(response);
        if (response.status === "Success") {
          setTemplates(response?.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchTemplates(company);
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  async function createInspection({ id, schedule_id }) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let inspection_obj = {
      schedule_id,
      template_id: id,
      user_id: data.user_id,
      company_id: company.id,
      created_by: data.user_id,
    };

    
    if (packageDetails.inspection_request_status === "Request is Valid") {
      fetch(GlobalApi + "/Inspection/create_inspection", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(inspection_obj),
      })
        .then((response) => response.json())
        .then(async (res1) => {
          console.log(res1);
          fetch(GlobalApi + "/InspectionShare/create_inspection_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              inspection_id: res1.data.id,
              user_id: data.user_id,
              created_by: data.user_id,
              role: "Owner",
              isAdmin: true,
              isEditor: true,
            }),
          })
            .then((response) => response.json())
            .then(async (res) => {
              console.log(res);
              if (packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") {
               navigator.geolocation.getCurrentPosition(function(position) {
                console.log("Latitude is :", position.coords.latitude);
                console.log("Longitude is :", position.coords.longitude);

                fetch(GlobalApi + "/Inspection/save_inspector_loc", {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({inspection_id:res1.data.id,
                    latitude:position.coords.latitude,
                    longitude:position.coords.longitude}),
                })
                  .then((response) => response.json())
                  .then(async (data) => {
                    console.log(data)
                  });
              });
            }else{
              
              fetch(GlobalApi + "/Inspection/save_inspector_loc", {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({inspection_id:res1.data.id,
                  latitude:null,
                  longitude:null}),
              })
                .then((response) => response.json())
                .then(async (data) => {
                  console.log(data)
                });
            }
              history.push("inspection-edit/" + res1.data.id + "/edit");
            });
        });
    } else {
      swal(t("Warning"), packageDetails.inspection_request_status, "warning");
    }
  }

  function handleStart(schedule_id, template_id) {

    
    navigator.geolocation.getCurrentPosition(function(position) {
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
    });
    console.log(schedule_id, template_id);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      schedule_id,
      template_id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(
      GlobalApi + "/TemplateInspection/get_template_for_inspection?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status === "Success") {
          if (response?.data) {
            createInspection(response?.data);

            console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            handleStart(schedule_id, template_id);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  // const handleTemplateSearch = (e) => {
  //   var data = e;
  //   console.log(e);
  //   if (data == "cleared") {
  //     const Status = schedules.filter(
  //       (Status) => "Active" === Status.Status
  //     );

  //     // const All = schedules;

  //     setState({
  //       ...state,
  //       filter_arr: Status,
  //     });
  //   } else {
  //     const Listing = schedules.filter((sch) => e === sch.template_id);
  //     setState({
  //       ...state,
  //       filter_arr: Listing,
  //     });
  //   }
  // };

  const groups = _.groupBy(schedules, "filter_date");
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  function handlePackage(e) {
    setIsModalOpen(false);

    history.push(e);
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const ModalOpen = (reponse) => {
    //alert(reponse.id);

    setIsModalOpen(reponse);
  };
  const groups1 = _.groupBy(
    state.filter_arr != null ? state.filter_arr : schedules,
    "filter_date"
  );

  //console.log(schedules);
  const list =
    Object.keys(groups1).length !== 0 ? (
      Object.keys(groups1)
        .sort((a, b) => new Date(a) - new Date(b))
        .map((key, index) => {
          return groups1[key]
            .filter(
              (v) =>
                v?.title?.toLowerCase().includes(searchText?.toLowerCase()) ||
                v?.Template?.title
                  ?.toLowerCase()
                  .includes(searchText?.toLowerCase()) ||
                v?.Site?.title
                  ?.toLowerCase()
                  .includes(searchText?.toLowerCase()) ||
                v?.User?.first_name
                  ?.toLowerCase()
                  .includes(searchText?.toLowerCase()) ||
                v?.User?.last_name
                  ?.toLowerCase()
                  .includes(searchText?.toLowerCase())
            )
            .map((response, ini) => {
              console.log(response, ":::::::::::::::::::::::");
              return (
                <React.Fragment key={ini}>
                  {ini == 0 && (
                   language == "ar" ? <TableRow
                   className="active-schedule"
                   style={{ border: "1px solid #dadada" }}
                 >
                   <TableCell style={{ padding: 11 }} />
                   <TableCell style={{ padding: 11 }} />
                   <TableCell style={{ padding: 11 }} />
                   <TableCell style={{ padding: 11 }} />
                   <TableCell style={{ padding: 11 }} />
                   <TableCell style={{ padding: "10px" }}>
                     <div>
                       <Typography
                         style={{
                           fontWeight: "bold",
                           color: Colors.globalColor8,
                           fontSize: 12,
                         }}
                       >
                         
                         {moment(response.filter_date).format(
                           "MMMM DD, YYYY"
                         )}
                       </Typography>
                     </div>
                   </TableCell>
                  
                 </TableRow> : <TableRow
                      className="active-schedule"
                      style={{ border: "1px solid #dadada" }}
                    >
                      <TableCell style={{ padding: "10px" }}>
                        <div>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              color: Colors.globalColor8,
                              fontSize: 12,
                            }}
                          >
                           

                            {moment(response.filter_date).format(
                              "MMMM DD, YYYY"
                            )}
                          </Typography>
                        </div>
                      </TableCell>
                      <TableCell style={{ padding: 11 }} />
                      <TableCell style={{ padding: 11 }} />
                      <TableCell style={{ padding: 11 }} />
                      <TableCell style={{ padding: 11 }} />
                      <TableCell style={{ padding: 11 }} />
                    </TableRow>
                  )}
                  <TableRow className="pointer-cursor">
                    <TableCell
                      style={{ padding: 10, textTransform: "capitalize",textAlign:language == "ar" ? "right" : "left" }}
                    >
                      {
                        <Tooltip title={response?.title ? response?.title : ""}>
                          <p style={{ margin: 0 }}>
                            {response?.title.slice(0, 30) +
                              (response?.title.length > 30 ? "..." : "")}
                          </p>
                        </Tooltip>
                      }
                    </TableCell>

                    <TableCell
                      style={{
                        padding: 10,
                        textTransform: "capitalize",
                        borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                        textAlign:language == "ar" ? "right" : "left"
                      }}
                    >
                      {
                        <Tooltip
                          title={
                            response?.Template?.title
                              ? response?.Template?.title
                              : ""
                          }
                        >
                          <p style={{ margin: 0 }}>
                            {response?.Template?.title.slice(0, 30) +
                              (response?.Template?.title.length > 30
                                ? "..."
                                : "")}
                          </p>
                        </Tooltip>
                      }
                    </TableCell>

                    <TableCell
                      style={{ padding: 10, textTransform: "capitalize",textAlign:language == "ar" ? "right" : "left" }}
                    >
                      {
                        <Tooltip
                          title={
                            response?.Site?.title ? response?.Site?.title : ""
                          }
                        >
                          <p style={{ margin: 0 }}>
                            {response?.Site?.title.slice(0, 15) +
                              (response?.Site?.title.length > 15 ? "..." : "")}
                          </p>
                        </Tooltip>
                      }
                    </TableCell>

                    {/* <TableCell>
              {moment(response.end_date).format("MMMM DD, YYYY")}
            </TableCell> */}
                    <TableCell
                      style={{
                        padding: 2,
                        textTransform: "capitalize",
                        borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                        textAlign:language == "ar" ? "right" : "left"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                        }}
                      >
                        {response?.ScheduleAssignees?.map((v, i) => {
                          if (i <= 2) {
                            return (
                              <Tooltip
                                title={`${v.User ? v.User.first_name : ""} ${
                                  v.User ? v.User.last_name : ""
                                }`}
                                aria-label=""
                              >
                                {v.User.avatar !== null ? (
                                  <div
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: "50px",
                                      color: "#043077",
                                      display: "flex",
                                      justifyContent: "center",
                                      margin: 1,
                                      alignItems: "center",
                                      backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                        v.User.avatar
                                      })`,
                                      backgroundSize: "cover",
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: "50px",
                                      border: "1px solid #043077",
                                      color: "#043077",
                                      display: "flex",
                                      justifyContent: "center",
                                      margin: 1,
                                      alignItems: "center",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: 0,
                                        fontWeight: "bold",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {v.User
                                        ? v.User.first_name
                                            .substring(0, 1)
                                            .toUpperCase()
                                            .concat(
                                              v.User
                                                ? v.User.last_name
                                                    .substring(0, 1)
                                                    .toUpperCase()
                                                : ""
                                            )
                                        : ""}
                                    </p>
                                  </div>
                                )}
                              </Tooltip>
                            );
                          } else {
                            return (
                              <div
                                style={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: "50px",
                                  border: "1px solid #043077",
                                  color: "#043077",
                                  display: "flex",
                                  justifyContent: "center",
                                  margin: 1,
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                  }}
                                >
                                  +{response?.ScheduleAssignees?.length - 3}
                                </p>
                              </div>
                            );
                          }
                        })}
                      </div>
                    </TableCell>
                    <TableCell
                      style={{ padding: 5, textTransform: "capitalize",textAlign:language == "ar" ? "right" : "left" }}
                    >
                      {response?.User && response?.User?.first_name}{" "}
                      {response?.User && response?.User?.last_name}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 2,
                        textTransform: "capitalize",
                        textAlign: "center",
                        borderLeft: language == "ar" ? "none" : "1px solid #dadada",
                        borderRight: language == "ar" ?  "1px solid #dadada" :"none" ,
                      }}
                    >
                      {moment(new Date()).format("MMMM DD, YYYY") ==
                      moment(response?.filter_date).format("MMMM DD, YYYY") ? (
                        <>
                          {(packageDetails?.inspection_limit != "Unlimited" ? (
                            parseInt(packageDetails?.inspection_limit) >
                            parseInt(packageDetails?.inspection_count)
                          ) : (
                            true
                          )) ? (
                            <Button
                              size="small"
                              className="startInspectionBtnSmall"
                              style={{ backgroundColor: Colors.globalColor8 }}
                              onClick={() => {
                                // ModalOpen(response);
                                handleStart(response.id, response.template_id);
                              }}
                            >
                              {t("Start Inspection")}
                            </Button>
                          ) : (
                            <Button
                              size="small"
                              className="startInspectionBtnSmall"
                              style={{ backgroundColor: Colors.globalColor8 }}
                              onClick={() => {
                                history.push("/update_package");
                              }}
                            >
                              {t("Upgrade Package")}
                            </Button>
                          )}
                        </>
                      ) : (
                        <Button
                          size="small"
                          className="startInspectionBtnSmall2"
                          disabled
                          style={{ backgroundColor: "grey" }}
                        >
                          {t("Start Inspection")}
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            });
        })
    ) : (
      <TableRow style={{ border: "1px solid #dadada" }}>
        <TableCell colSpan={6}>
          <NoRecords />
        </TableCell>
      </TableRow>
    );

  console.log(state);
  if (packageDetails !== null) {
    return (
      <div style={{ padding: window.innerWidth > 500 ? "10px" : "5px" }}>
        <main>
          {scheduleLoader && (
            <div
              style={{
                height: "50vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner />
            </div>
          )}

          {!scheduleLoader && (
            <div style={{ width: "100%" }}>
              {window.innerWidth > 500 && (
                <TableContainer
                  id="schedule1Scroll"
                  className={classes.container}
                >
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    style={{
                      minWidth: 900,
                      width: "100%",
                      borderLeft: "1px solid #dadada",
                      borderRight: "1px solid #dadada",
                    }}
                  >
                    <TableHead className="" style={{}}>
                      <TableRow>
                        <TableCell
                          style={{
                            padding: "8px 10px",
                            textAlign: language == "ar" ? "right": "left",
                            borderTop: "1px solid #dadada",
                            backgroundColor: "#f2f2f2",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Schedule")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: "8px 10px",
                            textAlign: language == "ar" ? "right": "left",
                            borderLeft: "1px solid #dadada",
                            borderRight: "1px solid #dadada",
                            borderTop: "1px solid #dadada",
                            backgroundColor: "#f2f2f2",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Template")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: "8px 10px",
                            textAlign: language == "ar" ? "right": "left",
                            borderTop: "1px solid #dadada",
                            backgroundColor: "#f2f2f2",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Site")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: "8px 10px",
                            textAlign: language == "ar" ? "right": "left",
                            borderLeft: "1px solid #dadada",
                            borderRight: "1px solid #dadada",
                            borderTop: "1px solid #dadada",
                            backgroundColor: "#f2f2f2",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Assignees")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: "8px 10px",
                            textAlign: language == "ar" ? "right": "left",
                            borderTop: "1px solid #dadada",
                            backgroundColor: "#f2f2f2",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            {t("Assigned by")}
                          </p>
                        </TableCell>
                        <TableCell
                          style={{
                            padding: "8px 10px",
                            textAlign: language == "ar" ? "right": "left",
                            borderTop: "1px solid #dadada",
                            borderLeft: language == "ar" ? "none" : "1px solid #dadada",
                            borderRight: language == "ar" ?  "1px solid #dadada" :"none" ,
                            backgroundColor: "#f2f2f2",
                          }}
                        >
                          <p
                            className="label2"
                            style={{
                              marginTop: 0,
                              color: Colors.globalColor8,
                              fontWeight: "bold",
                              fontSize: 12,
                              textTransform: "uppercase",
                            }}
                          >
                            
                            {t("Action")}
                          </p>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>{list}</TableBody>
                  </Table>
                </TableContainer>
              )}

              {window.innerWidth <= 500 && (
                <div
                  className={classes.container}
                  style={{ overflowY: "scroll", width: "100%", padding: "5px" }}
                  id="schedule1Scroll"
                >
                  {Object.keys(groups1).length !== 0 ? (
                    Object.keys(groups1)
                      .sort((a, b) => new Date(a) - new Date(b))
                      .map((key, index) => {
                        return groups1[key]
                          .filter(
                            (v) =>
                              v?.title
                                ?.toLowerCase()
                                .includes(searchText?.toLowerCase()) ||
                              v?.Template?.title
                                ?.toLowerCase()
                                .includes(searchText?.toLowerCase()) ||
                              v?.Site?.title
                                ?.toLowerCase()
                                .includes(searchText?.toLowerCase()) ||
                              v?.User?.first_name
                                ?.toLowerCase()
                                .includes(searchText?.toLowerCase()) ||
                              v?.User?.last_name
                                ?.toLowerCase()
                                .includes(searchText?.toLowerCase())
                          )
                          .map((response, ini) => {
                            console.log(response, ":::::::::::::::::::::::");
                            return (
                              <React.Fragment key={ini}>
                                {ini == 0 && (
                                  <div
                                    className="active-schedule"
                                    style={{
                                      border: "1px solid #dadada",
                                      padding: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    <p
                                      className="label2"
                                      style={{
                                        textAlign:   "left",
                                        marginTop: 0,
                                        fontSize: 12,
                                        color: Colors.globalColor8,
                                      }}
                                    >
                                      {moment(response.filter_date).format(
                                        "MMMM DD, YYYY"
                                      )}
                                    </p>
                                  </div>
                                )}

                                <div
                                  className="hover shadow"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    border: "1px solid #dadada",
                                    padding: "10px",
                                    margin: "5px",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    textAlign: "left",
                                    height: "220px",
                                    borderRadius: "5px",
                                    backgroundColor: "white",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      height: "100%",
                                      flexDirection: "column",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div>
                                      <p
                                        style={{
                                          color: Colors.globalColor8,
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          textAlign: "left",
                                          marginBottom: "0px",
                                          marginTop: "0px",
                                        }}
                                      >
                                        {t("Schedule")}
                                      </p>

                                      <p
                                        style={{
                                          fontSize: "12px",
                                          textAlign: "left",
                                          marginBottom: "0px",
                                          marginTop: "0px",
                                        }}
                                      >
                                        {response?.title.slice(0, 30) +
                                          (response?.title.length > 30
                                            ? "..."
                                            : "")}
                                      </p>
                                    </div>
                                    <div>
                                      <p
                                        style={{
                                          color: Colors.globalColor8,
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          textAlign: "left",
                                          marginBottom: "0px",
                                          marginTop: "0px",
                                        }}
                                      >
                                        {t("Template")}
                                      </p>
                                      <p
                                        style={{
                                          fontSize: "12px",
                                          textAlign: "left",
                                          marginBottom: "0px",
                                          marginTop: "0px",
                                        }}
                                      >
                                        {response?.Template?.title.slice(
                                          0,
                                          30
                                        ) +
                                          (response?.Template?.title.length > 30
                                            ? "..."
                                            : "")}
                                      </p>
                                    </div>
                                    <div>
                                      <p
                                        style={{
                                          color: Colors.globalColor8,
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          textAlign: "left",
                                          marginBottom: "0px",
                                          marginTop: "0px",
                                        }}
                                      >
                                        Site{" "}
                                      </p>
                                      <p
                                        style={{
                                          fontSize: "12px",
                                          textAlign: "left",
                                          marginBottom: "0px",
                                          marginTop: "0px",
                                        }}
                                      >
                                        <p style={{ margin: 0 }}>
                                          {response?.Site?.title.slice(0, 15) +
                                            (response?.Site?.title.length > 15
                                              ? "..."
                                              : "")}
                                        </p>
                                      </p>
                                    </div>
                                    <div>
                                      <p
                                        style={{
                                          color: Colors.globalColor8,
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          textAlign: "left",
                                          marginBottom: "0px",
                                          marginTop: "0px",
                                        }}
                                      >
                                       {t("Assigned to")}{" "}
                                      </p>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "flex-start",
                                        }}
                                      >
                                        {response?.ScheduleAssignees?.map(
                                          (v, i) => {
                                            if (i <= 2) {
                                              return (
                                                <Tooltip
                                                  title={`${
                                                    v.User
                                                      ? v.User.first_name
                                                      : ""
                                                  } ${
                                                    v.User
                                                      ? v.User.last_name
                                                      : ""
                                                  }`}
                                                  aria-label=""
                                                >
                                                  {v.User.avatar !== null ? (
                                                    <div
                                                      style={{
                                                        width: 30,
                                                        height: 30,
                                                        borderRadius: "50px",
                                                        color: "#043077",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        margin: 1,
                                                        alignItems: "center",
                                                        backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                          v.User.avatar
                                                        })`,
                                                        backgroundSize: "cover",
                                                      }}
                                                    />
                                                  ) : (
                                                    <div
                                                      style={{
                                                        width: 30,
                                                        height: 30,
                                                        borderRadius: "50px",
                                                        border:
                                                          "1px solid #043077",
                                                        color: "#043077",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        margin: 1,
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <p
                                                        style={{
                                                          margin: 0,
                                                          fontWeight: "bold",
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        {v.User
                                                          ? v.User.first_name
                                                              .substring(0, 1)
                                                              .toUpperCase()
                                                              .concat(
                                                                v.User
                                                                  ? v.User.last_name
                                                                      .substring(
                                                                        0,
                                                                        1
                                                                      )
                                                                      .toUpperCase()
                                                                  : ""
                                                              )
                                                          : ""}
                                                      </p>
                                                    </div>
                                                  )}
                                                </Tooltip>
                                              );
                                            } else {
                                              return (
                                                <div
                                                  style={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: "50px",
                                                    border: "1px solid #043077",
                                                    color: "#043077",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    margin: 1,
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      margin: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "10px",
                                                    }}
                                                  >
                                                    +
                                                    {response?.ScheduleAssignees
                                                      ?.length - 3}
                                                  </p>
                                                </div>
                                              );
                                            }
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      height: "100%",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <div>
                                      {moment(new Date()).format(
                                        "MMMM DD, YYYY"
                                      ) ===
                                      moment(response?.filter_date).format(
                                        "MMMM DD, YYYY"
                                      ) ? (
                                        <>
                                          {(packageDetails?.inspection_limit !=
                                          "Unlimited" ? (
                                            parseInt(packageDetails?.inspection_limit) >
                                            parseInt(packageDetails?.inspection_count)
                                          ) : (
                                            true
                                          )) ? (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                              onClick={() => {
                                                handleStart(
                                                  response.id,
                                                  response.template_id
                                                );
                                              }}
                                            >
                                              <img
                                                src={startG}
                                                alt="file"
                                                width={20}
                                              />
                                              <p
                                                style={{
                                                  margin: "5px 0 0 0",
                                                  fontSize: 8,
                                                }}
                                              >
                                                Start
                                              </p>
                                              <p
                                                style={{
                                                  margin: 0,
                                                  fontSize: 8,
                                                }}
                                              >
                                                Inspection
                                              </p>
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                              onClick={() => {
                                                history.push("/update_package");
                                              }}
                                            >
                                              <img
                                                src={up}
                                                alt="file"
                                                width={20}
                                              />
                                              <p
                                                style={{
                                                  margin: "5px 0 0 0",
                                                  fontSize: 8,
                                                }}
                                              >
                                                upgrade
                                              </p>
                                              <p
                                                style={{
                                                  margin: 0,
                                                  fontSize: 8,
                                                }}
                                              >
                                                Package
                                              </p>
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <img
                                            src={start}
                                            alt="file"
                                            width={20}
                                          />
                                          <p
                                            style={{
                                              margin: "5px 0 0 0",
                                              fontSize: 8,
                                              color: "#dadada",
                                            }}
                                          >
                                            Start
                                          </p>
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 8,
                                              color: "#dadada",
                                            }}
                                          >
                                            Inspection
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          });
                      })
                  ) : (
                    <div
                      style={{
                        height: "45vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <NoRecords />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </main>
        {isModalOpen && (
          <ScheduleModal
            templates={templates}
            data={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            users={users}
            handlePackage={handlePackage}
          />
        )}
      </div>
    );
  } else {
    return (
      <div
        style={{
          height: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }
}
